
import React from 'react';
import {
    RichTextField,
    Tab,
    FormTab,
    BooleanField,
    ReferenceInput,
    SimpleFormIterator,
    TextField,
    ArrayField,
    Datagrid,
    ReferenceField,
    FormDataConsumer,
    useResourceContext
} from 'react-admin';
import { VersioningTypeInput } from "../../../lib/VersioningTypeInput";
import {
    ArrayInput,
    AutocompleteInput,
    BooleanInput,
    RichTextInput,
    TextInput,
} from '../../../lib/wrappers/Inputs';

import { Typography,Box, Divider, Chip } from '@mui/material';
var titleStyle = { color: "#AE223F" }
var labelStyle = {
    color: '#000000',
    opacity: 0.8,
    padding: 0,
    fontsize: 1,
    fontweight: 400, lineheight: 1, letterspacing: 0.00938
}
export const CourseSpecificationsInputTab = (source) => {
    const resource = useResourceContext();

    return (
        <FormTab label="Course Specifications" {...source}>
             <Box flex={4} sx={{ paddingBottom: '20px' }}>
                <Typography variant="h6" style={titleStyle}>
                    Course | <small><TextField source="id" label={false} /></small> | <small><TextField source="courseCode" label={false} /></small>
                </Typography>
            </Box>
            <Box display="flex" width={1}>
                <Box flex={1}>
                    <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="DBS Check" /></b></Divider>
                </Box>
            </Box>
            <Box display="flex" width={1}>
            
                <Box flex={1}>
                    <BooleanInput source="requiresDBScheck" />
                </Box>
                <Box flex={5} ml="0.5em">
                    <FormDataConsumer>
                        {({ formData, ...rest }) => formData.requiresDBScheck && (
                            <TextInput
                                source="enhancedOrStandard"
                                {...rest}
                                fullWidth />
                        )}
                    </FormDataConsumer>
                </Box>
            </Box>
            <Box display="flex" width={1}>
                <Box flex={2}>
                    <Box display="flex" width={1}>
                        <Box flex={1}>
                            <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Entry Requirements" /></b></Divider>
                        </Box>
                    </Box>
                    <RichTextInput source="entryRequirements" fullWidth label={false} />
                    <Box display="flex" width={1}>
                        <Box flex={1}>
                            <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Employer Engagement" /></b></Divider>
                        </Box>
                    </Box>
                    <RichTextInput source="employerEngagement" fullWidth label={false} />
                    <Box display="flex" width={1}>
                        <Box flex={1}>
                            <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Learning Support" /></b></Divider>
                        </Box>
                    </Box>
                    <RichTextInput source="learningSupport" fullWidth label={false} />
                    <Box display="flex" width={1}>
                        <Box flex={1}>
                            <Divider flexItem textAlign="center" sx={{ marginBottom: '15px' }}><b style={labelStyle}><Chip sx={{ fontSize: '1.2em' }} label="Means Of Assessment" /></b></Divider>
                        </Box>
                    </Box>
                    <RichTextInput source="meansOfAssessment" fullWidth label={false} />
                </Box>
            </Box>
            <VersioningTypeInput source="versioningType" resource={resource} />
        </FormTab>
    );
};

export const CourseSpecificationsShowTab = (source) => (
    <Tab label="Course Specifications" {...source}>
        <BooleanField source="requiresDBScheck" />
        <TextField source="enhancedOrStandard" />
        <RichTextField source="entryRequirements" />
        <ArrayField source="exitPoints">
            <Datagrid>
                <ReferenceField
                    source="qualificationId"
                    reference="QualificationType"
                    link="show"
                >
                    <TextField source="Title" label="Title" />
                </ReferenceField>
                <TextField source="criteria" label="Criteria" />
                <TextField source="certificateTitle" label="Course 
                Title" />
                <BooleanField source="exitPointFinal" />
            </Datagrid>
        </ArrayField>
    </Tab>
);
